var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{attrs:{"app":""}},[_c('v-container',{staticClass:"pt-6 main-view-admin-area"},[_c('v-expand-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_c('div',{staticClass:"flex-grow-1"}),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }